import {
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type INativeSelectProps from "./type";
import NativeSelectSheet from "./components/sheet";
import NativeSelectWeb from "./components/web";

const NativeSelect: FC<INativeSelectProps> = (props) => {
    if(Platform.OS === "web") {
        return <NativeSelectWeb
            {...props}
        />;
    }

    return <NativeSelectSheet
        {...props}
    />;
};
export default NativeSelect;
